//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sportType_detail, sportType_update, oss_files } from '@/apis/config'
export default {
    data() {
        const rules = {
            name: [{ required: true, message: '請輸入運動名稱！' }],
            status: [{ required: true, message: '請選擇狀態！' }],
            imageUrl: [{ required: true, message: '請上傳圖標！' }],
        };

        const formState = {
            name: '',
            status: '',
            imageUrl: '',
        };
        return {
            id: '',
            visible: false,
            title: '運動類型表單',
            fileList: [],
            previewImage: {},
            previewVisible: false,
            fileLoading: false,
            formState,
            rules,
            fornLoading: false,
            labelCol: {
                style: {
                    width: '150px',
                },
            },
            wrapperCol: {
                span: 14,
            },
            footerStyle: {
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 1
            }
        };
    },
    methods: {
        // 顯示抽屜
        showDrawer(id) {
            if (id) {
                this.id = id;
                this.onPageLoad();
            }
            this.visible = true;
        },

        // 關閉抽屜
        onClose() {
            this.visible = false;
            this.resetForm();
        },

        async onPageLoad() {
            try {
                const res = await sportType_detail(this.id) || {};
                if (res.code == 0) {
                    const item = res.data || {};
                    const form = { ...this.formState };
                    form.id = this.id;
                    form.name = item.name;
                    form.imageUrl = item.imageUrl;
                    form.status = `${item.status}`;
                    this.formState = form;
                    this.onLoadFile();
                } else {
                    if (res.msg) throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },

        async onLoadFile() {
            function getFileName(path) {
                const regex = /([^\/\\]+)$/;
                const match = regex.exec(path);
                if (match) {
                    return match[1];
                } else {
                    return null;
                }
            }
            const url = this.formState.imageUrl;
            if (url) {
                this.fileList = [{
                    uid: '-1',
                    name: getFileName(url),
                    status: 'done',
                    url: url
                }]
            }
        },

        // 重置表單
        resetForm() {
            this.formState.name = undefined;
            this.formState.status = undefined;
            this.formState.imageUrl = undefined;
            this.fileList = [];
        },

        // 提交表單
        handleSubmit(e) {
            e.preventDefault();
            this.$refs.form.validate(async valid => {
                console.log(valid);
                if (valid) {
                    try {
                        this.fileLoading = true;
                        const res = await sportType_update(this.formState) || {};
                        if (res.code == 0) {
                            this.onClose();
                            this.$emit('submit', this.formState);
                        } else {
                            if (res.msg)
                                throw new Error(res.msg);
                        }
                    } catch (error) {
                        this.$message.error(error.message);
                    } finally {
                        this.fileLoading = false;
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //圖片上傳
        async handleFileChange({ fileList }) {
            console.log('handleFileChange', fileList);
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData);
                    if (res.code == 0) {
                        this.formState.imageUrl = res.data;
                        this.fileList = validFiles;
                        this.$refs.imageUrlModelItem.clearValidate();
                    } else {
                        this.$message.error(res.msg);
                    }
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            } else {
                this.fileList = fileList;
                this.formState.imageUrl = undefined;
            }

        },
        async handleFilePreview(file) {
            function getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            }
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handlePreviewCancel() {
            this.previewVisible = false;
        },
    }
};
